import {_} from 'lodash';
import * as ko from "knockout";
import {ICompanyLogin, IOrganization} from "../../../index";
import {global, lm} from "../../../appContext";
import {IComboboxV2Options} from "../../combobox/v2";
import {nsTooltip} from "../../../util/nsTooltip";
import {storeObservable} from "../../../util/sessionstore";
import organization_pickerHtml from './organization-picker.html?raw';

export let template: string = organization_pickerHtml;

export class viewModel {

    public selectedOrganization: KnockoutObservable<IOrganization | null>;
    public organizations: KnockoutObservableArray<IOrganization>;
    private pv = global.permissionValidator;
    private v2Options: IComboboxV2Options<IOrganization>

    constructor() {
        this.organizations = global.login.organizations;
        this.selectedOrganization = global.login.selectedOrganization;

        this.v2Options = {
            prepareData: {
                map: arr => {
                    const companylogin_selected = storeObservable('selected.company.login')() as ICompanyLogin;
                    if (companylogin_selected?.vanityindex) {
                        // replace the name with the one from companylogin
                        const a = _.cloneDeep(arr)
                        const item = a.find((o: IOrganization) => o.organizationid == companylogin_selected.orgnr)
                        if (item) {
                            item.organizationame = companylogin_selected.name
                        }
                        return a
                    }
                    return arr
                }
            },
            inputAttrs: {
                placeholder: lm.t('choose organization'),
                title: lm.t('choose organization'),
                ariaLabel: lm.t('choose organization'),
            },
            wrapperClass:'combobox-organization',
            caret: 'light',
            enable: ko.pureComputed(() => !global.login.isProcessing() && this.isSelectable()),
            option: {
                label: (o: IOrganization | null) => o?.organizationame ?? '',
                tooltip: (o: IOrganization | null) => o ? (lm.t(nsTooltip.getTitle_organization(o)) ?? '') : '',
                key: (o: IOrganization) => o.organizationid,
            },
            initialMatch: o => o.organizationid == this.selectedOrganization()?.organizationid,
            restoreLastValidOnBlur: true,
            selected: this.selectedOrganization,
            data: this.organizations,
        };
    }

    isSelectable = ko.pureComputed(() => {
        return this.organizations().length > 1;
    });

}
